import { gql } from "@apollo/client";


  export const CREATE_SYMPOSIUM_PHOTOS = gql`
mutation UploadAppImage($input: [AppImageUploadInput!]!) {
  uploadAppImage(input: $input) {
    success
    message
    image {
      id
      s3_key
      filename
      folder
      url
      mime_type
      status
      created_at
      updated_at
    }
    images {
      id
      s3_key
      filename
      folder
      url
      mime_type
      status
      created_at
      updated_at
    }
    error
  }
}
  `


  export const UPDATE_SYMPOSIUM_PHOTOS = gql`
mutation UpdateAppImagesStatus($items: [AppImageStatusUpdateInput!]!) {
  updateAppImagesStatus(items: $items) {
    success
    message
    image {
      id
      s3_key
      filename
      folder
      url
      mime_type
      status
      created_at
      updated_at
    }
    error
  }
}
`


export const CREATE_OR_UPDATE_SYMPOSIUM_DATA = gql`
mutation CreateOrUpdateEvent($input: EventsInput) {
  createOrUpdateEvent(input: $input) {
    success
    message
    event {
      arcimedes_row_id
      title
      description
      text
      date
      videoLinks {
        url
      }
      photos {
         id
       filename
       url
       s3_key
       status
      }
      deleted
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
`